import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PhotoSubmission = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', phone: '', message: '' });
    }, 3000);
  };

  const handleWhatsAppSubmit = () => {
    const message = encodeURIComponent(
      `Hi Chapati Plus! I'd like to share my food photos.\n\nName: ${formData?.name}\nPhone: ${formData?.phone}\nMessage: ${formData?.message}`
    );
    window.open(`https://wa.me/211123456789?text=${message}`, '_blank');
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg p-6 md:p-8 lg:p-10">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
          <Icon name="Camera" size={32} color="var(--color-primary)" />
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
          Share Your Chapati Plus Experience
        </h2>
        <p className="text-muted-foreground text-sm md:text-base lg:text-lg mb-6 md:mb-8">
          We love seeing your food photos! Share your experience and get featured in our gallery
        </p>

        {submitted ? (
          <div className="bg-success/10 border border-success rounded-lg p-6 md:p-8">
            <Icon name="CheckCircle2" size={48} color="var(--color-success)" className="mx-auto mb-4" />
            <h3 className="text-success text-lg md:text-xl font-bold mb-2">Thank You!</h3>
            <p className="text-foreground text-sm md:text-base">
              We've received your submission. Our team will review it shortly!
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <Input
                label="Your Name"
                type="text"
                placeholder="Enter your name"
                value={formData?.name}
                onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
                required
              />
              <Input
                label="Phone Number"
                type="tel"
                placeholder="+211 XXX XXX XXX"
                value={formData?.phone}
                onChange={(e) => setFormData({ ...formData, phone: e?.target?.value })}
                required
              />
            </div>

            <Input
              label="Tell us about your experience"
              type="text"
              placeholder="What did you love about your meal?"
              value={formData?.message}
              onChange={(e) => setFormData({ ...formData, message: e?.target?.value })}
              required
            />

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <Button
                type="submit"
                variant="default"
                size="lg"
                iconName="Send"
                iconPosition="right"
              >
                Submit via Email
              </Button>
              <Button
                type="button"
                variant="default"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={handleWhatsAppSubmit}
                className="bg-accent hover:bg-accent/90"
              >
                Submit via WhatsApp
              </Button>
            </div>

            <p className="text-xs md:text-sm text-muted-foreground">
              By submitting, you agree to let us feature your photos in our gallery and social media
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default PhotoSubmission;